import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type CheckProps = IconComponentBaseProps;

export const Check = ({
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
  className,
}: CheckProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <mask
        id="mask0_7617_2387"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill={fill} />
      </mask>
      <g mask="url(#mask0_7617_2387)">
        <path
          d="M9.55001 15.5155L18.1885 6.87699C18.3372 6.72816 18.5112 6.65216 18.7105 6.64899C18.9098 6.64582 19.0871 6.72182 19.2423 6.87699C19.3974 7.03216 19.475 7.21032 19.475 7.41149C19.475 7.61282 19.3974 7.79107 19.2423 7.94624L10.1828 17.0212C10.0019 17.2019 9.79101 17.2922 9.55001 17.2922C9.30901 17.2922 9.09809 17.2019 8.91726 17.0212L4.74226 12.8462C4.59359 12.6974 4.52026 12.5207 4.52226 12.3162C4.52409 12.1119 4.60259 11.9322 4.75776 11.777C4.91292 11.6218 5.09109 11.5442 5.29226 11.5442C5.49359 11.5442 5.67184 11.6218 5.82701 11.777L9.55001 15.5155Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
